var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6074_153745)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3738 18.1562H36.8087C36.275 18.1562 35.8423 18.589 35.8423 19.1227C35.8423 19.6564 36.275 20.0891 36.8087 20.0891H38.9081L26.8919 30.3173C26.66 30.5149 26.3379 30.5138 26.1059 30.3152L14.0919 20.0902H16.1805C16.7142 20.0902 17.147 19.6575 17.147 19.1238C17.147 18.5901 16.7142 18.1573 16.1805 18.1573H12.6262C11.4536 18.1573 10.5 19.112 10.5 20.2835V36.6593C10.5 37.8384 11.4536 38.7962 12.6262 38.7962H40.3738C41.5464 38.7962 42.5 37.8373 42.5 36.6593V20.2835C42.5 19.1109 41.5464 18.1562 40.3738 18.1562ZM40.5671 21.2177V35.7337L32.0399 28.4757L40.5671 21.2177ZM26.5 32.4005C27.0852 32.4005 27.6694 32.1965 28.1462 31.7895L30.5483 29.745L38.9102 36.8634H14.0887L22.4506 29.745L24.8506 31.7874C25.3295 32.1954 25.9148 32.4005 26.5 32.4005ZM20.9601 28.4746L12.4329 35.7337V21.2177L20.9601 28.4746Z",
    fill: "#535862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2055 24.1262C26.301 24.1563 26.3998 24.1724 26.4986 24.1724C26.5974 24.1724 26.6973 24.1563 26.7929 24.1262C29.8071 23.163 34.3902 20.05 33.8554 15.7976C33.6009 13.7906 32.4294 12.2615 30.722 11.7096C29.2981 11.2532 27.7496 11.5539 26.4986 12.4978C25.2498 11.5549 23.6981 11.2532 22.2763 11.7106C20.5679 12.2615 19.3963 13.7906 19.1419 15.7976C18.6039 20.0532 23.188 23.1641 26.2055 24.1262ZM21.0608 16.0414C21.2197 14.7775 21.8801 13.8701 22.8712 13.5501C23.1129 13.4717 23.3631 13.4341 23.6133 13.4341C24.3864 13.4341 25.1757 13.7939 25.7931 14.4553C25.9746 14.6508 26.2302 14.7614 26.4986 14.7614C26.7671 14.7614 27.0227 14.6497 27.2052 14.4543C28.0235 13.577 29.1445 13.229 30.1271 13.549C31.1172 13.869 31.7776 14.7775 31.9376 16.0392C32.293 18.857 29.0619 21.2666 26.4986 22.1847C23.9343 21.2688 20.7032 18.8602 21.0608 16.0414Z",
    fill: "#85242D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6074_153745",
    x: 0.5,
    y: 0.5,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6074_153745"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6074_153745",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketDone);
export default __webpack_public_path__ + "static/media/ticketDone.0f94e32e3b251654b2ecbf55334e6c19.svg";
export { ForwardRef as ReactComponent };